<template>
  <ul class="product-tags">
    <li v-for="tag in tags" :key="tag.Id" v-text="tag.Name"></li>
  </ul>
</template>

<script>
export default {
  props: {
    tags: {
      type: Array,
      default: () => [],
    },
  },
}
</script>
